import React, { useEffect, useState } from 'react'
import SSOSecured from './SSOSecured'
import { checkLoginMode } from '../../services/Security'
import { ssoClient } from '../../services/SigninSetup'
import BypassSecured from './BypassSecured'

function Secured({ claim, force, children }) {
  const [loginType, setLoginType] = useState(undefined)

  useEffect(() => {
    setLoginType(checkLoginMode())
  }, [])

  const selectComponentSecured = () => {
    let component = undefined

    if (!loginType) return <></>

    if (loginType === 'bypass') {
      component = <BypassSecured claim={claim}>{children}</BypassSecured>
    } else if (loginType === 'google') {
      component = (
        <SSOSecured client={ssoClient} claim={claim}>
          {children}
        </SSOSecured>
      )
    }

    return component
  }

  return selectComponentSecured()
}

export default Secured
